import styled from "styled-components";
import { generic } from "../../../../../ui/_themes/constants";
import { Buttons } from "./Buttons";

export const Title = styled.div`
  text-align: center;
  font-size: 1.4em;
  line-height: 1.4em;
  color: ${generic.dialogs.title.color};
  flex: 0 0 auto;
  overflow-wrap: break-word;

  & + ${Buttons} {
    margin: 1.4em 0 0;
  }
`;
